// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ce888285","453":"f3160035","455":"9e87b5ef","977":"a87cd32c"}[chunkId] + ".chunk.js";
};